/**
 * Tab của màn Cấu hình lỗi & thông báo (`/rpa/alert-config?tab=`). Native có `errors`, `notifications`, `senders`
 * (`alert-config.ts`); thêm tab mới `connection` (kết nối OpenCore của tenant, ADR-0103 mục 5).
 */
export const TAB_CAU_HINH = ['errors', 'notifications', 'senders', 'connection'] as const;
export type TabCauHinh = (typeof TAB_CAU_HINH)[number];

export const THAM_SO_TAB = 'tab';

/** Tab trên URL nếu người dùng được xem, không thì tab đầu tiên được xem; `null` khi không xem được tab nào. */
export function tabMoSan(giaTri: string | null, duocXem: readonly TabCauHinh[]): TabCauHinh | null {
  return duocXem.find((t) => t === giaTri) ?? duocXem[0] ?? null;
}
